import { render, staticRenderFns } from "./PesquisaMensagemVeto.vue?vue&type=template&id=a70482ea&scoped=true"
import script from "./PesquisaMensagemVeto.vue?vue&type=script&lang=js"
export * from "./PesquisaMensagemVeto.vue?vue&type=script&lang=js"
import style0 from "./PesquisaMensagemVeto.vue?vue&type=style&index=0&id=a70482ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70482ea",
  null
  
)

export default component.exports